import { AGENT_ENVIRONMENT_VARIABLES } from "./constants.js";

const isEnvironmentVariableSet = (variable: string): boolean => Boolean(process.env[variable]);

export const detectNonInteractive = (yesFlag: boolean): boolean =>
  yesFlag || AGENT_ENVIRONMENT_VARIABLES.some(isEnvironmentVariableSet) || !process.stdin.isTTY;
